import { ProcessedSMSHistory } from '../ContactDrawer.utils';
import { MessageSquare, MessageSquareReply } from 'lucide-react';

import styles from '../ContactDrawer.module.scss';

export const SMSItem = ({ id, date, message, messageDirection, status, disposition }: ProcessedSMSHistory) => {
    return (
        <div className={`${styles.timelineItem} ${styles.sms}`} key={id}>
            <div className={styles.timelineDate}>
                <div className='flex items-center gap-sm' style={{ minHeight: '32px' }}>
                    <MessageSquare size={16} className='text-success' />

                    <span className='text-success font-semibold'>SMS </span>
                    <span className='text-gray-500'>|</span>
                    <span className='font-semibold'>
                        {date.toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                        })}
                    </span>
                </div>
                <div className='flex items-center justify-between gap-sm mt-sm'>
                    <div>
                        {messageDirection === 'INBOUND' && (
                            <MessageSquareReply size={14} className={`${styles.callDirectionIcon} ${styles.inbound}`} />
                        )}
                        {messageDirection === 'OUTBOUND' && (
                            <MessageSquare size={14} className={`${styles.callDirectionIcon} ${styles.outbound}`} />
                        )}
                        {date.toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                        })}
                    </div>
                    <div>
                        <span className={`${styles.callStatusBadge} ${styles[status.toLowerCase().replace(/_/g, '')]}`}>
                            {status.replace(/_/g, ' ')}
                        </span>
                    </div>
                </div>
            </div>
            <div className={styles.timelineContent}>
                <div className={styles.callDetails}>
                    <div className={styles.callDetailItem}>
                        <span className={styles.callDetailLabel}>Direction:</span> {messageDirection}
                    </div>
                    <div className={styles.callDetailItem}>
                        <span className={styles.callDetailLabel}>Disposition:</span> {disposition}
                    </div>
                    <div className={`${styles.callDetailItem} items-start`}>
                        <span className={styles.callDetailLabel}>Message:</span> {message}
                    </div>
                </div>
            </div>
        </div>
    );
};
